import { render, staticRenderFns } from "./ReplyForm.vue?vue&type=template&id=00d500ef&"
import script from "./ReplyForm.vue?vue&type=script&lang=js&"
export * from "./ReplyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports